const shuffle = (items) => {
  const result = [...items];
  for (let index = result.length - 1; index > 0; index -= 1) {
    const otherIndex = Math.floor(Math.random() * (index + 1));
    [result[index], result[otherIndex]] = [result[otherIndex], result[index]];
  }
  return result;
};

const ANTA = '\u0623\u064e\u0646\u0652\u062a\u064e';
const HIYA = '\u0647\u0650\u064a\u064e';
const ADDRESSEES = [ANTA, '\u0623\u064e\u0646\u0652\u062a\u0650', '\u0623\u064e\u0646\u0652\u062a\u064f\u0645\u0652', '\u0623\u064e\u0646\u0652\u062a\u064f\u0646\u064e\u0651'];

export function buildBinyan5PresentPronounSequence(verbs, pronouns) {
  const secondaryIndexes = verbs.reduce((indexes, verb, index) => {
    const binyan = String(verb['בניין'] || verb.binyan || '').replace('בניין ', '').trim();
    if (binyan === '2') indexes.push(index);
    return indexes;
  }, []);
  if (verbs.length !== 8 || secondaryIndexes.length !== 3) {
    throw new Error('Binyan 5 present analysis requires five primary and three secondary verbs.');
  }

  const restricted = shuffle(pronouns.filter(pronoun => ADDRESSEES.includes(pronoun.arabic))).slice(0, 2);
  if (restricted.length !== 2) throw new Error('Not enough addressee pronouns.');

  const usedPronouns = new Set(restricted.map(pronoun => pronoun.arabic));
  // Anta and hiya have identical present forms, so the third secondary question cannot use hiya after anta.
  const third = shuffle(pronouns.filter(pronoun =>
    !usedPronouns.has(pronoun.arabic) && !(usedPronouns.has(ANTA) && pronoun.arabic === HIYA)
  ))[0];
  if (!third) throw new Error('No eligible third secondary pronoun.');
  usedPronouns.add(third.arabic);

  const remaining = shuffle(pronouns.filter(pronoun => !usedPronouns.has(pronoun.arabic)));
  if (remaining.length < 5) throw new Error('Not enough unique primary pronouns.');

  const assignments = new Map(secondaryIndexes.map((index, position) => [index, [...restricted, third][position]]));
  return verbs.map((_, index) => assignments.get(index) || remaining.pop());
}
